import { useEffect, useState } from 'react';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import type { TEvent } from '@alfa-bank/site-analytics-event-sender/src/core/models';
import type { IApplicationSlice } from '@alfa-bank/site-dc-form-api/src/store/features/models';
import {
    deliveryStepAnalytics,
    thanksStepAnalytics,
} from '@alfa-bank/site-dc-form-screens/analytics';

import {
    firstStepAnalytics,
    smsStepAnalytics,
    passportStepAnalytics,
    errorStepAnalytics,
    draftStepAnalytics,
    changePhoneNumberStepAnalytics,
    verifySmsStepAnalytics,
} from '../analytics';

const analytics: Record<IApplicationSlice['step'], Record<string, object> | undefined> = {
    firstStep: firstStepAnalytics,
    smsConfirm: smsStepAnalytics,
    passport: passportStepAnalytics,
    delivery: deliveryStepAnalytics,
    error: errorStepAnalytics,
    thanksPage: thanksStepAnalytics,
    draft: draftStepAnalytics,
    changePhoneNumber: changePhoneNumberStepAnalytics,
    checkData: undefined,
    gentleErrorPage: undefined,
};

export const useAnalytics = (
    step: IApplicationSlice['step'],
    status: IApplicationSlice['status']
) => {
    const [prevStep, setPrevStep] = useState('');

    useEffect(() => {
        if (analytics[step]) {
            if (step === 'smsConfirm') {
                if (status === 'NEED_SMS') {
                    sendEvent(verifySmsStepAnalytics.view as unknown as TEvent);
                } else {
                    sendEvent(smsStepAnalytics.view as unknown as TEvent);
                }
            } else {
                sendEvent(analytics[step]?.view);
            }

            if (step === 'firstStep') {
                sendEvent(firstStepAnalytics.fullName.view);
                sendEvent(firstStepAnalytics.phone.view);
                sendEvent(firstStepAnalytics.email.view);
            }

            if (prevStep === 'smsConfirm' && !['error', 'changePhoneNumber'].includes(step)) {
                sendEvent(smsStepAnalytics.submit.success);
            }
        }

        setPrevStep(step);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [step]);
};
